import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, Events } from 'ionic-angular';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { AppState } from '../../config/state';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';

/**
 * Generated class for the CoLogoutSurveyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-logout-survey',
  templateUrl: 'co-logout-survey.html',
})
export class CoLogoutSurveyPage {
  confirmScreen: boolean = true;
  surveyQuestions: any;
  surveyEnabled: boolean = true;

  constructor(public navCtrl: NavController, public navParams: NavParams, private viewCtrl : ViewController, private toast : ToastAlertsProvider, private state: AppState, private events : Events, private timeout : TimeoutFunctionsProvider, private sounds : SoundsProvider) {
    // this.surveyEnabled = this.state.surveyEnabled;
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.surveyQuestions = [
      {text: "Customer Service", rating: 0},
      {text: "Facilities at this branch", rating: 0},
      {text: "Cleanliness of this branch", rating: 0},
      {text: "Availability of items at this branch", rating: 0},
      {text: "Opening hours of this branch", rating: 0},
    ]
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  goToSurvey(bool){
    if (bool){
      this.confirmScreen = false;
    } else {
      this.viewCtrl.dismiss().catch(err=>{});
    };
  }

  submitSurvey(){
    let output = true;
    this.surveyQuestions.forEach(ques => {
      if (ques.rating <= 0){
        output = false;
      }
    });
    if (output){
      this.toast.triggerToast('Thank you for your valued opinion!','');
      this.viewCtrl.dismiss().catch(err=>{});
    } else {
      this.toast.triggerToast('Oops! Please rate all questions before you send','');
    }
  }

  resetQuestions(){
    this.surveyQuestions.forEach(ques => {
      ques.rating = 0;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/co-logout-survey/co-logout-survey.ts